export enum ViewBreakpoint {
  SM = 768,
  MD = 1024,
  LG = 1366,
  XLG = 1600,
}
